import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'
import Textarea from '../Textarea'

const NpsTextArea = ({
  questionText,
  questionSubText,
  name,
  onFocusOut,
  onChange,
  value,
  isRequired = false
}) => {

  return (
    <>
      <div className='NpsTextArea'>
        <div className='NpsTextArea__text'>
          <Typography
            weight='bolder'
            variant='content1'
            center
          >
            {questionText}
          </Typography>
        </div>
        {
          questionSubText && (
            <div className='NpsTextArea__subtext'>
              <Typography 
                variant='content2'
                center
              >
                {questionSubText}
              </Typography>
            </div>
          )
        }

        <div className='NpsTextArea__textarea'>
          <Textarea  
            inputHeight='100px'
            placeholder='Digite sua mensagem'
            id={name}
            name={name}
            onBlur={onFocusOut}
            onChange={onChange}
            value={value}
          />

          {isRequired && (
            <Typography variant='content3' italic>
              * Preenchimento obrigatório.
            </Typography>
          )}
        </div>
      </div> 
    </>
  )
}

export default NpsTextArea